module.exports = "/_next/static/images/nums-d2e87649.png";